import Context from "../../../context/Context";

export function getRangeClause(field,dtStart,dtEnd) {
  const start = getZulu(dtStart);
  const end = getZulu(dtEnd);
  let clause = "(" + field + " >= TIMESTAMP '" + start + "'";
  clause += " AND " + field + " <= TIMESTAMP '" + end + "')";
  return clause;
}

function getZulu(date) {
  const lib = Context.getInstance().lib;
  const opts = {zulu: true};
  let v = lib.dojo.stamp.toISOString(date,opts);
  v = v.replace("T"," ").replace("Z","");
  return v;
}

export function toEndOfDay(date) {
  let dt = toStartOfDay(date);
  dt.setDate(dt.getDate() + 1);
  dt = new Date(dt.getTime() - 1);
  return dt;
}

export function toStartOfDay(date) {
  const dt = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );
  return dt;
}
